const Vue = require('vue')
const template = require('templates/ui-pagination.html')
const { range } = require('sci/helpers/prelude')

Vue.component('ui-pagination', {
    template: template,

    props: ['data', 'page-changed', 'no-scroll'],

    created: function () {

    },

    methods: {
        pullPage: function (page) {
            if (!this.noScroll) {
                window.scrollTo(0, 0)
            }

            this.pageChanged(page)
        },
        change: function (page) {
            this.pullPage(page.number)
        },
        next: function () {
            if (this.hasNext) {
                this.pullPage(this.data.current_page + 1)
            }
        },
        prev: function () {
            if (this.hasPrev) {
                this.pullPage(this.data.current_page - 1)
            }
        },
        first: function () {
            this.pullPage(1)
        },
        last: function () {
            this.pullPage(this.data.total_pages)
        }
    },

    watch: {
        data: function (newValue) {
        }
    },

    computed: {
        pages: function () {
            if (!this.data || this.data.total === 0) {
                return []
            }

            const { current_page, total_pages } = this.data

            let pageButtons = range(1, total_pages + 1)
                .filter(item => {
                    if ((item <= 3 && current_page < 3) || (item <= current_page + 1 && item >= current_page - 1)) {
                        return true
                    }
                    return (item > (total_pages - 3))
                }).map((item) => {
                    return { number: item, current: item == current_page }
                })

            const isSequential = pageButtons.reduce((accumulator, item, index, all) => {
                const prev = all[index - 1]

                return accumulator && (prev ? (prev.number + 1 === item.number) : true)
            }, true)

            if (pageButtons.length == 6 && !isSequential) {
                pageButtons = [
                    ...pageButtons.slice(0, 3),
                    { number: null },
                    ...pageButtons.slice(3, 6)
                ]
            }

            return pageButtons
        },
        hasPrev: function () {
            return this.data.current_page > 1
        },
        hasNext: function () {
            return this.data.current_page < this.data.total_pages
        }
    }
})

// total_pages, current_page, total



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/ui-pagination.js